export enum PassengerType {
  ADT = 'ADT',
  CHD = 'CHD',
  INF = 'INF',
}
